import { AxiosInstance } from "axios";
import ProductInterface from "@/types/app/products";

export async function getProduct(url: string, id: string, api: AxiosInstance) {
  const response = await api.get(`${url}/${id}`);
  const product = response.data as ProductInterface;
  return product;
}
